<template>
  <div>
    <div
      v-if="errors.length"
      class="va-message-list"
      :style="colorComputed"
    >
      <div
        class="va-message-list__message"
        v-for="(message, index) in errors"
        :key="index"
      >
        {{message}}
      </div>
    </div>
  </div>
</template>

<script>
import { ColorThemeMixin } from '../../services/vuestic-ui'
export default {
  name: 'ErrorMessages',
  mixins: [ColorThemeMixin],
  props: {
    errors: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang='scss'>
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}
</style>
